<template>
  <div class="holidaydel">
    <Header title="销假申请"></Header>
    <div class="holidaydel-body">
      <div class="holidaydel-inputs">
        <div class="holidaydel-input">
          <van-field
            v-model="xjsj.mc"
            label="销假时间"
            right-icon="arrow"
            input-align="right"
            placeholder="请点击选择"
            readonly
            @click="onShow1('销假时间', 'xjsj')"
          />
        </div>
        <div class="holidaydel-input">
          <van-field
            v-model="person"
            label="审核人"
            input-align="right"
            placeholder="请点击选择"
            right-icon="arrow"
            readonly
            @click="isPopShow()"
          />
        </div>
        <div class="holidaydel-input">
          <van-field
            v-model="xjsm"
            label="销假说明"
            input-align="right"
            type="textarea"
            placeholder="请点击填写"
          />
        </div>
      </div>
    </div>
    <button class="holidaydel-btn" @click="submitApply()">保存并送审</button>
    <!-- 审核人popup -->
    <van-popup v-model="isShow" position="bottom">
      <div class="holidaydel-pop">
        <div class="pop-title">
          <i class="close-icon" @click="isShow = false"></i>
          <p>审核人</p>
          <i class="confirm-icon" @click="resetCancel()"></i>
        </div>
        <div class="person">
          <button
            class="per-btn"
            ref="person"
            @click="personTap($event, index)"
            v-for="(item, index) in personList"
            :key="item.id"
          >
            {{ item.name }}
          </button>
        </div>
      </div>
    </van-popup>
    <van-popup v-model="show1" round position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="datetime"
        :title="valueList.label"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="
          (value, index) => {
            onConfirm1(value, index, valueList.value);
          }
        "
      />
    </van-popup>
  </div>
</template>

<script>
import { Api } from "@/utils/axios";
export default {
  data() {
    return {
      minDate: new Date(2020, 0, 1),
      maxDate: new Date(2025, 10, 1),
      currentDate: new Date(),
      xjsj: {},
      xjsm: "",
      day: "0",
      show1: false,
      columns: {},
      valueList: {
        label: "",
        value: "",
        item: []
      },
      personList: [
        {
          id: "",
          name: "全部",
          isBtn: 0
        }
      ],
      person: "",
      personId: "",
      reset: "",
      resetId: "",
      isShow: false,
      yw: ""
    };
  },
  created() {
    this.getList();
  },
  methods: {
    async getList() {
      const res = await Api.xsxjsq({
        xsqjid: this.$route.query.list.xsqjid
      });
      this.day = res.data.qjts;
      this.getPeople();
    },
    async submitApply() {
      if (
        JSON.stringify(this.xjsj) == "{}" ||
        this.xjsm == "" ||
        this.person == ""
      ) {
        this.$toast.fail("请填写完整~");
        return;
      }
      const res = await Api.xsxjsq_save({
        xsqjid: this.$route.query.list.xsqjid,
        xsxjid: this.$route.query.list.xsxjid,
        ywcode: this.yw,
        xjsj: this.xjsj.dm,
        xjyy: this.xjsm,
        userids: this.personId
      });

      if (res.code == 1) {
        this.$toast.success("销假申请成功!");
        setTimeout(() => {
          this.$router.replace("/holiday/index");
        }, 1500);
      } else {
        this.$toast.fail(res.Msg);
      }
    },
    // 弹出选择器
    onShow1(label, value) {
      this.show1 = true;
      this.valueList.label = label;
      this.valueList.value = value;
    },
    onConfirm1(value, index, value1) {
      this.show1 = false;
      let chooseDate = new Date(value);
      this[value1].mc = this.formatSjMc(chooseDate);
      this[value1].dm = this.formatSjDm(chooseDate);
    },
    formatSjMc(date) {
      return (
        (date.getFullYear() < 10
          ? "0" + date.getFullYear()
          : date.getFullYear()) +
        "年" +
        (Number(date.getMonth()) + 1 < 10
          ? "0" + (Number(date.getMonth()) + 1)
          : Number(date.getMonth()) + 1) +
        "月" +
        (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) +
        "日 " +
        (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) +
        "时" +
        (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
        "分"
      );
    },
    formatSjDm(date) {
      return (
        (date.getFullYear() < 10
          ? "0" + date.getFullYear()
          : date.getFullYear()) +
        "-" +
        (Number(date.getMonth()) + 1 < 10
          ? "0" + (Number(date.getMonth()) + 1)
          : Number(date.getMonth()) + 1) +
        "-" +
        (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) +
        " " +
        (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) +
        ":" +
        (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
        ":00"
      );
    },
    // 审核人
    resetCancel() {
      this.isShow = false;
      this.person = this.reset;
      this.personId = this.resetId;
    },
    async getPeople() {
      this.yw = "386-1";
      if (this.day >= 7 && this.day <= 14) {
        this.yw = "386-2";
      } else if (this.day > 15) {
        this.yw = "386-3";
      }
      const params = {
        ywcode: this.yw,
        ywid: ""
      };
      const res = await Api.selectReviewerApi(params);
      let concatList = [];
      res.data.forEach((item, index) => {
        concatList[index] = {
          name: item.userrealname,
          id: item.userid,
          isBtn: 0
        };
      });
      this.personList = this.personList.concat(concatList);
    },
    isPopShow() {
      this.isShow = !this.isShow;
    },
    close() {
      this.isShow = false;
    },
    personTap(e, res) {
      let strList = [];
      let idList = [];
      if (this.personList[res].isBtn == 0) {
        this.personList[res].isBtn = 1;
        e.target.className = "cur";
      } else if (this.personList[res].isBtn == 1) {
        this.personList[res].isBtn = 0;
        e.target.className = "per-btn";
      }
      for (let i in this.personList) {
        if (this.personList[res].name == "全部") {
          this.personList[i].isBtn = 0;
          this.personList[res].isBtn = 1;
          this.$refs.person[res].className = "cur";
          this.$refs.person[i].className = "per-btn";
        } else {
          this.personList[0].isBtn = 0;
          this.$refs.person[0].className = "per-btn";
        }
        if (this.personList[i].isBtn == 1) {
          strList = strList.concat(this.personList[i].name);
          idList = idList.concat(this.personList[i].id);
        }
      }
      this.reset = strList.toString();
      this.resetId = idList.toString();
    }
  }
};
</script>

<style lang="less" scoped>
.holidaydel-body {
  padding: 0 20px;
  .attention {
    color: red;
    font-size: 12px;
  }
}
.holidaydel-body .holidaydel-title {
  font-size: 18px;
  color: @attendance-color-1;
  font-weight: 600;
}
.holidaydel-body .holidaydel-num {
  font-size: 14px;
  color: @attendance-color-2;
  margin-top: 8px;
}
.holidaydel-inputs {
  margin-top: 17px;
}
.holidaydel-inputs .holidaydel-input {
  padding: 9px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid @attendance-border-color-6;
  color: @attendance-color-1;
}
.holidaydel-input input {
  flex: 1;
  text-align: right;
  color: @attendance-color-1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding-left: 20px;
}
.holidaydel-input input::placeholder {
  color: @attendance-background-color-2;
  font-size: 16px;
}
.holidaydel .holidaydel-btn {
  position: absolute;
  bottom: 20px;
  background-color: @attendance-background-color-1;
  padding: 11px 0;
  color: @attendance-color-3;
  border-radius: 3px;
  width: 90%;
  margin-left: 5%;
}

// 审核人
.holidaydel-pop {
  width: 100%;
  position: fixed;
  bottom: 0;
  background-color: @attendance-color-3;
  box-sizing: border-box;
  border-radius: 5px 5px 0 0;
  max-height: 40%;
  overflow-y: scroll;
}
.close-icon {
  background: url(../../../../../static/img/close.png) no-repeat center;
}
.pop-title {
  display: flex;
  justify-content: space-between;
  padding: 13px;
  position: fixed;
  width: 100%;
  background-color: @attendance-color-3;
  box-sizing: border-box;
  border-radius: 5px 5px 0 0;
  z-index: 9;
}
.pop-title i {
  width: 22px;
  height: 22px;
  background-size: 22px 22px;
}
.confirm-icon {
  background: url(../../../../../static/img/confirm.png) no-repeat center;
}
.holidaydel-pop .person {
  padding: 20px 20px 0;
  display: flex;
  flex-wrap: wrap;
  margin-top: 48px;
}
.person button {
  border-radius: 3px;
  padding: 5px 15px;
  margin-right: 12px;
  margin-bottom: 15px;
}
.holidaydel-pop .person .per-btn {
  background-color: @attendance-background-color-7;
  color: @attendance-background-color-1;
}
.person .cur {
  background-color: @attendance-background-color-1;
  color: @attendance-background-color-7;
}
</style>
<style lang="less">
.holidaydel-inputs {
  .van-cell {
    padding: 0;
  }
  .van-cell__title,
  .van-cell.van-field .van-cell__title.van-field__label > span {
    width: auto;
    height: 22px;
    font-family: PingFangSC-Light;
    font-size: 16px;
    color: #212f6e;
    letter-spacing: 0;
    flex: inherit;
  }
  .van-icon-eye {
    font-family: "iconfont" !important;
    font-size: 22px;
    font-style: normal;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #212f6e;
  }
  .van-icon-eye::before {
    content: "\e6be";
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/student/holiday/del.vue